import { gql } from "@apollo/client";

export const GET_ALL_PATIENT_LIST = gql`
  query GetPatients($input: BasePaginationParams!) {
    getPatients(input: $input) {
      patients {
        _id
        firstName
        lastName
        medicalRecordNumber
      }
      pagination {
        total
        hasNextPage
      }
    }
  }
`;

export const GET_PATIENTS_BY_MRNS = gql`
  query GetPatientsByMRNs($input: GetPatientsByMRNInput!) {
    getPatientsByMRNs(input: $input) {
      message
      pagination {
        hasNextPage
        total
      }
      patients {
        _id
        medicalRecordNumber
        firstName
        lastName
        age
        contacts {
          emailDetail
          phone {
            dialCode
            number
            type
          }
        }
        diabetes
        glucose {
          highest
          lowest
        }
        glucoseTestingLast24Hrs
        hbA1c
        hypoGlycaemiaRiskScore
        location {
          _id
          displayAddress
        }
        weight
        unit {
          _id
          name
        }
        psmg
        pdwmg
      }
    }
  }
`;
